import Wix from '../services/wix-sdk-polyfill';
import { isInWix } from '../services/is-in-wix';

export const ABOUT_WIDGET_ENTER_EDITING = 'WIX_ABOUT_WIDGET_ENTER_EDITING';
export const ABOUT_WIDGET_CLOSE_EDITING = 'WIX_ABOUT_WIDGET_CLOSE_EDITING';
export const ABOUT_WIDGET_ENTER_TEXT_STYLE_PAGE = 'WIX_ABOUT_WIDGET_ENTER_TEXT_STYLE_PAGE';
export const ABOUT_WIDGET_LEAVE_TEXT_STYLE_PAGE = 'WIX_ABOUT_WIDGET_LEAVE_TEXT_STYLE_PAGE';
export const ABOUT_WIDGET_ENTER_EMPTY_STATE_TAB = 'WIX_ABOUT_WIDGET_ENTER_EMPTY_STATE_TAB';
export const ABOUT_WIDGET_LEAVE_EMPTY_STATE_TAB = 'WIX_ABOUT_WIDGET_LEAVE_EMPTY_STATE_TAB';
export const ABOUT_EDIT_OPEN_DISCARD_MODAL = 'WIX_ABOUT_EDIT_OPEN_DISCARD_MODAL';

export const PROFILE_WIDGET_NON_SOCIAL_EDIT_OPEN = 'WIX_PROFILE_WIDGET_NON_SOCIAL_EDIT_OPEN';
export const PROFILE_WIDGET_NON_SOCIAL_EDIT_CLOSE = 'WIX_PROFILE_WIDGET_NON_SOCIAL_EDIT_CLOSE';
export const PROFILE_WIDGET_MOBILE_POPUP_INITIALIZED = 'WIX_PROFILE_WIDGET_MOBILE_POPUP_INITIALIZED';

export const BADGES_PREVIEW_OPEN = 'WIX_BADGES_PREVIEW_OPEN';
export const BADGES_PREVIEW_CLOSE = 'WIX_BADGES_PREVIEW_CLOSE';

const isWix = isInWix();

export const dispatchToWix = (event, data = {}) => (dispatch, getState) =>
  isWix
    ? Wix.PubSub.publish(event, {
        ...data,
        compId: getState().site.originalComponentId,
      })
    : dispatch({ type: event, ...data });

export default {
  ABOUT_WIDGET_ENTER_EDITING,
  ABOUT_WIDGET_CLOSE_EDITING,
  ABOUT_WIDGET_ENTER_TEXT_STYLE_PAGE,
  ABOUT_WIDGET_LEAVE_TEXT_STYLE_PAGE,
  ABOUT_WIDGET_ENTER_EMPTY_STATE_TAB,
  ABOUT_WIDGET_LEAVE_EMPTY_STATE_TAB,
  ABOUT_EDIT_OPEN_DISCARD_MODAL,
  PROFILE_WIDGET_NON_SOCIAL_EDIT_OPEN,
  PROFILE_WIDGET_NON_SOCIAL_EDIT_CLOSE,
  PROFILE_WIDGET_MOBILE_POPUP_INITIALIZED,
  BADGES_PREVIEW_OPEN,
  BADGES_PREVIEW_CLOSE,
};
